import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { key: 7 }
const _hoisted_15 = { key: 8 }
const _hoisted_16 = { key: 9 }
const _hoisted_17 = { key: 10 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            _createVNode(_component_router_link, {
              to: "/fournisseurs/liste-fournisseurs",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, null, -1),
                _createTextVNode("Retour")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              (_ctx.fournisseur?.statut)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _cache[2] || (_cache[2] = _createElementVNode("td", null, "Statut :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur.statut == 1 ? 'Personne physique' : 'Personne morale'), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.nomFournisseur)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("td", null, "Nom :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.nomFournisseur), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.prenomFournisseur)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "Prénom :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.prenomFournisseur), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.adresseFournisseur)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("td", null, "Adresse fournisseur :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.adresseFournisseur), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.email)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, "Email :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.telephoneFournisseur1)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("td", null, "Téléphone 1 :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.telephoneFournisseur1), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.telephoneFournisseur2)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, "Téléphone 2 :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.telephoneFournisseur2), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.raisonSociale)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("td", null, "Raison sociale :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.raisonSociale), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.ifu)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _cache[10] || (_cache[10] = _createElementVNode("td", null, "Ifu :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.ifu), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.denomination)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _cache[11] || (_cache[11] = _createElementVNode("td", null, "Dénomination :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.denomination), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.fournisseur?.dateCreation)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _cache[12] || (_cache[12] = _createElementVNode("td", null, "Date création :", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.fournisseur?.dateCreation), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}